import { takeEvery } from 'redux-saga/effects';

import { collectFeedback } from '@/modules/api/codegen';

import { sendFeedbackType } from './actions';

function* worker({ payload: feedback }: ReturnType<typeof sendFeedbackType>) {
    yield collectFeedback({ feedback });
}

export function* saga() {
    yield takeEvery(sendFeedbackType.toString(), worker);
}
